
import { useCallback } from 'react';
import type { GameData } from './types';

export const useGameDataValidation = () => {
  /**
   * Check if game data has meaningful progress
   */
  const hasGameProgress = useCallback((data: GameData) => {
    return data.bestScore > 0 || data.totalGamesPlayed > 0 || data.unlockedFacts.length > 0;
  }, []);

  return {
    hasGameProgress
  };
};
